/*!
 * Copyright Zendesk, Inc.
 * 
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0
 */
(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports,
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 14);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports) {
  module.exports = require("prop-types");
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  // extracted by mini-css-extract-plugin
  module.exports = {
    "c-menu": "index__c-menu___2cUzq",
    "is-open": "index__is-open___1zKbs",
    "c-menu--down": "index__c-menu--down___3GVy6",
    "zd-menu--down-open": "index__zd-menu--down-open___6RQfY",
    "zd-menu--down-open-arrow": "index__zd-menu--down-open-arrow___2YFIR",
    "c-menu--left": "index__c-menu--left___26KN5",
    "zd-menu--left-open": "index__zd-menu--left-open___2LrL2",
    "zd-menu--left-open-arrow": "index__zd-menu--left-open-arrow___FjIs-",
    "c-menu--right": "index__c-menu--right___11QUN",
    "zd-menu--right-open": "index__zd-menu--right-open___ndAw6",
    "zd-menu--right-open-arrow": "index__zd-menu--right-open-arrow___6fhGC",
    "c-menu--up": "index__c-menu--up___3PxhZ",
    "zd-menu--up-open": "index__zd-menu--up-open___3xEYz",
    "zd-menu--up-open-arrow": "index__zd-menu--up-open-arrow___3mQlW",
    "is-rtl": "index__is-rtl___19srM",
    "c-menu__item": "index__c-menu__item___Au0bj",
    "c-menu--sm": "index__c-menu--sm___12C-d",
    "c-menu__item--add": "index__c-menu__item--add___20uHw",
    "c-menu__item--header": "index__c-menu__item--header___2pTCl",
    "c-menu__item--previous": "index__c-menu__item--previous___BAJx8",
    "c-menu__item--header--icon": "index__c-menu__item--header--icon___3_Emn",
    "c-menu__item--header__icon": "index__c-menu__item--header__icon___11tgI",
    "c-menu__item--next": "index__c-menu__item--next___3y9nm",
    "is-checked": "index__is-checked___2F44A",
    "c-menu__item__meta": "index__c-menu__item__meta___COt_5",
    "c-menu__item--media": "index__c-menu__item--media___33tEA",
    "c-menu__item--media__figure": "index__c-menu__item--media__figure___3h5lQ",
    "c-menu__item--media__body": "index__c-menu__item--media__body___LEdTg",
    "is-focused": "index__is-focused___2h4vL",
    "is-hovered": "index__is-hovered___18xby",
    "is-disabled": "index__is-disabled___3llMj",
    "is-expanded": "index__is-expanded___AbErG",
    "is-hidden": "index__is-hidden___23DVM",
    "c-menu__separator": "index__c-menu__separator___1a4HS"
  };
  /***/
},
/* 2 */

/***/
function (module, exports) {
  module.exports = require("@zendeskgarden/react-theming");
  /***/
},
/* 3 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 4 */

/***/
function (module, exports) {
  module.exports = require("styled-components");
  /***/
},
/* 5 */

/***/
function (module, exports) {
  module.exports = require("@zendeskgarden/react-selection");
  /***/
},
/* 6 */

/***/
function (module, exports, __webpack_require__) {
  // extracted by mini-css-extract-plugin
  module.exports = {
    "c-arrow": "index__c-arrow___1av8j",
    "c-arrow--t": "index__c-arrow--t___2WoBi",
    "c-arrow--tl": "index__c-arrow--tl___t8_U6",
    "c-arrow--tr": "index__c-arrow--tr___XNq6R",
    "c-arrow--r": "index__c-arrow--r___2qwef",
    "c-arrow--rb": "index__c-arrow--rb___2HhiV",
    "c-arrow--rt": "index__c-arrow--rt___1uq0Z",
    "c-arrow--l": "index__c-arrow--l___3imhv",
    "c-arrow--lb": "index__c-arrow--lb___1VbC8",
    "c-arrow--lt": "index__c-arrow--lt___17gla",
    "c-arrow--b": "index__c-arrow--b___2OIag",
    "c-arrow--bl": "index__c-arrow--bl___2iaPr",
    "c-arrow--br": "index__c-arrow--br___rjkSx"
  };
  /***/
},
/* 7 */

/***/
function (module, exports) {
  module.exports = require("@zendeskgarden/react-utilities");
  /***/
},
/* 8 */

/***/
function (module, exports) {
  module.exports = require("classnames");
  /***/
},
/* 9 */

/***/
function (module, exports) {
  module.exports = require("react-popper");
  /***/
},
/* 10 */

/***/
function (module, exports) {
  module.exports = require("react-portal");
  /***/
},
/* 11 */

/***/
function (module, exports) {
  module.exports = require("@zendeskgarden/react-tooltips");
  /***/
},
/* 12 */

/***/
function (module, exports) {
  module.exports = require("render-fragment");
  /***/
},
/* 13 */

/***/
function (module, exports) {
  module.exports = require("@zendeskgarden/react-modals");
  /***/
},
/* 14 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: external "react"


  var external_react_ = __webpack_require__(3);

  var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_); // EXTERNAL MODULE: external "prop-types"


  var external_prop_types_ = __webpack_require__(0);

  var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_); // EXTERNAL MODULE: external "styled-components"


  var external_styled_components_ = __webpack_require__(4);

  var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_); // EXTERNAL MODULE: external "react-popper"


  var external_react_popper_ = __webpack_require__(9); // EXTERNAL MODULE: external "react-portal"


  var external_react_portal_ = __webpack_require__(10); // EXTERNAL MODULE: external "render-fragment"


  var external_render_fragment_ = __webpack_require__(12);

  var external_render_fragment_default = /*#__PURE__*/__webpack_require__.n(external_render_fragment_); // EXTERNAL MODULE: external "@zendeskgarden/react-selection"


  var react_selection_ = __webpack_require__(5); // EXTERNAL MODULE: external "@zendeskgarden/react-tooltips"


  var react_tooltips_ = __webpack_require__(11); // EXTERNAL MODULE: external "@zendeskgarden/react-theming"


  var react_theming_ = __webpack_require__(2); // EXTERNAL MODULE: external "@zendeskgarden/react-modals"


  var react_modals_ = __webpack_require__(13); // CONCATENATED MODULE: ./src/containers/MenuContainer.js


  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    }
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * This container must provide a wrapper for the provided menu
   * due to constraints in our arrow css. We must ensure that the container
   * of the menu can retain its relative positioning. Without this
   * container Popper would apply absolute positioning.
   */


  var MenuWrapper = external_styled_components_default.a.div.withConfig({
    displayName: "MenuContainer__MenuWrapper",
    componentId: "qwv4oz-0"
  })(["z-index:", ";"], function (props) {
    return props.zIndex;
  });

  var MenuContainer_MenuContainer = /*#__PURE__*/function (_ControlledComponent) {
    _inherits(MenuContainer, _ControlledComponent);

    function MenuContainer() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, MenuContainer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MenuContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "getDocuments", function () {
        var doc = react_theming_["getDocument"] ? Object(react_theming_["getDocument"])(_this.props) : document;
        var iframes = doc.querySelectorAll('iframe');
        return _toConsumableArray(iframes).reduce(function (documents, iframe) {
          try {
            if (iframe.contentDocument) {
              return _toConsumableArray(documents).concat([iframe.contentDocument]);
            }
          } catch (e) {} // eslint-disable-line no-empty


          return documents;
        }, [doc]);
      });

      _defineProperty(_assertThisInitialized(_this), "handleOutsideMouseDown", function (event) {
        var _this$getControlledSt = _this.getControlledState(),
            isOpen = _this$getControlledSt.isOpen;

        var target = event.target,
            which = event.which;
        var isLeftClick = which === 1;

        if (!isOpen || !isLeftClick) {
          return;
        }

        if (_this.menuReference && !_this.menuReference.contains(target)) {
          if (_this.triggerReference && !_this.triggerReference.contains(target)) {
            _this.toggleMenuVisibility({
              closedByBlur: true
            });
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "toggleMenuVisibility", function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            defaultFocusedIndex = _ref.defaultFocusedIndex,
            focusOnOpen = _ref.focusOnOpen,
            closedByBlur = _ref.closedByBlur;

        var _this$getControlledSt2 = _this.getControlledState(),
            isOpen = _this$getControlledSt2.isOpen;

        var disabled = _this.props.disabled;

        _this.setControlledState({
          isOpen: disabled ? false : !isOpen,
          focusedKey: undefined,
          defaultFocusedIndex: defaultFocusedIndex,
          focusOnOpen: focusOnOpen,
          closedByBlur: closedByBlur
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getTriggerProps", function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref2$tabIndex = _ref2.tabIndex,
            tabIndex = _ref2$tabIndex === void 0 ? 0 : _ref2$tabIndex,
            onClick = _ref2.onClick,
            onKeyDown = _ref2.onKeyDown,
            other = _objectWithoutProperties(_ref2, ["tabIndex", "onClick", "onKeyDown"]);

        var _this$getControlledSt3 = _this.getControlledState(),
            isOpen = _this$getControlledSt3.isOpen;

        return _objectSpread({
          tabIndex: tabIndex,
          'aria-haspopup': true,
          'aria-expanded': isOpen,
          onClick: Object(react_selection_["composeEventHandlers"])(onClick, function () {
            return _this.toggleMenuVisibility();
          }),
          onKeyDown: Object(react_selection_["composeEventHandlers"])(onKeyDown, function (event) {
            var _VALID_OPEN_KEYS;

            var VALID_OPEN_KEYS = (_VALID_OPEN_KEYS = {}, _defineProperty(_VALID_OPEN_KEYS, react_selection_["KEY_CODES"].ENTER, true), _defineProperty(_VALID_OPEN_KEYS, react_selection_["KEY_CODES"].SPACE, true), _defineProperty(_VALID_OPEN_KEYS, react_selection_["KEY_CODES"].UP, true), _defineProperty(_VALID_OPEN_KEYS, react_selection_["KEY_CODES"].DOWN, true), _VALID_OPEN_KEYS);

            if (event.keyCode in VALID_OPEN_KEYS) {
              _this.toggleMenuVisibility({
                defaultFocusedIndex: event.keyCode === react_selection_["KEY_CODES"].UP ? -1 : 0,
                focusOnOpen: true
              });

              event.preventDefault();
              event.stopPropagation();
            }
          })
        }, other);
      });

      _defineProperty(_assertThisInitialized(_this), "triggerRef", function (reference) {
        if (reference) {
          _this.triggerReference = reference;
        }
      });

      _defineProperty(_assertThisInitialized(_this), "menuRef", function (reference) {
        if (reference) {
          _this.menuReference = reference;
        }
      });

      _defineProperty(_assertThisInitialized(_this), "onItemSelected", function (itemKey) {
        var onChange = _this.props.onChange;
        onChange && onChange(itemKey);
      });

      _defineProperty(_assertThisInitialized(_this), "getMenuProps", function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref3$tabIndex = _ref3.tabIndex,
            tabIndex = _ref3$tabIndex === void 0 ? -1 : _ref3$tabIndex,
            _ref3$role = _ref3.role,
            role = _ref3$role === void 0 ? 'menu' : _ref3$role,
            onKeyDown = _ref3.onKeyDown,
            onFocus = _ref3.onFocus,
            other = _objectWithoutProperties(_ref3, ["tabIndex", "role", "onKeyDown", "onFocus"]);

        var focusSelectionModel = arguments.length > 1 ? arguments[1] : undefined;

        var _this$getControlledSt4 = _this.getControlledState(),
            focusOnOpen = _this$getControlledSt4.focusOnOpen;

        return _objectSpread({
          role: role,
          tabIndex: tabIndex,
          onFocus: Object(react_selection_["composeEventHandlers"])(onFocus, function (event) {
            /**
             * If the Menu has been opened by a mouse we want to stop
             * the focus event from triggering the default focusing logic.
             */
            if (!focusOnOpen) {
              event.preventDefault();
            }
          }),
          onKeyDown: Object(react_selection_["composeEventHandlers"])(onKeyDown, function (event) {
            var _this$getControlledSt5 = _this.getControlledState(),
                focusedKey = _this$getControlledSt5.focusedKey;

            if (event.keyCode === react_selection_["KEY_CODES"].TAB) {
              if (event.shiftKey) {
                focusSelectionModel.selectPrevious();
              } else {
                focusSelectionModel.selectNext();
              }

              event.preventDefault();
              event.stopPropagation();
              return;
            }
            /**
             * Close menu on ESCAPE
             */


            if (event.keyCode === react_selection_["KEY_CODES"].ESCAPE) {
              _this.toggleMenuVisibility();

              event.preventDefault();
              event.stopPropagation();
              return;
            }

            if (event.keyCode === react_selection_["KEY_CODES"].RIGHT) {
              var directionalKey = Object(react_theming_["isRtl"])(_this.props) ? _this.previousKey : _this.nextKeys[focusedKey] && focusedKey;

              if (directionalKey) {
                _this.onItemSelected(directionalKey);

                event.preventDefault();
                event.stopPropagation();
                return;
              }
            }

            if (event.keyCode === react_selection_["KEY_CODES"].LEFT) {
              var _directionalKey = Object(react_theming_["isRtl"])(_this.props) ? _this.nextKeys[focusedKey] && focusedKey : _this.previousKey;

              if (_directionalKey) {
                _this.onItemSelected(_directionalKey);

                event.preventDefault();
                event.stopPropagation();
                return;
              }
            }

            if (event.keyCode !== react_selection_["KEY_CODES"].ALT) {
              var charString = event.key;

              var matchingSelectionModel = _this.textValueSelectionModels[charString.toLocaleUpperCase()];

              if (matchingSelectionModel) {
                matchingSelectionModel.selectionModel.selectNext();
                var matchingKey = matchingSelectionModel.keys[matchingSelectionModel.selectionModel.selectedIndex];

                _this.setControlledState({
                  focusedKey: matchingKey
                });
              }
            }
          })
        }, other);
      });

      _defineProperty(_assertThisInitialized(_this), "getItemProps", function (_ref4) {
        var key = _ref4.key,
            _ref4$role = _ref4.role,
            role = _ref4$role === void 0 ? 'menuitemcheckbox' : _ref4$role,
            textValue = _ref4.textValue,
            onMouseMove = _ref4.onMouseMove,
            other = _objectWithoutProperties(_ref4, ["key", "role", "textValue", "onMouseMove"]);

        var _this$getControlledSt6 = _this.getControlledState(),
            focusedKey = _this$getControlledSt6.focusedKey;

        if (typeof textValue === 'string' && textValue.length > 0) {
          var firstChar = textValue.toLocaleUpperCase().charAt(0);

          if (!_this.textValueSelectionModels[firstChar]) {
            _this.textValueSelectionModels[firstChar] = {
              keys: [],
              selectionModel: new react_selection_["SingleSelectionModel"]()
            };
          }

          var currentSelectionModel = _this.textValueSelectionModels[firstChar];
          currentSelectionModel.keys.push(key);
          currentSelectionModel.selectionModel.numItems++;

          if (key === focusedKey) {
            var focusedIndex = currentSelectionModel.keys.length - 1;
            currentSelectionModel.selectionModel.select(focusedIndex);
          }
        }

        return _objectSpread({
          key: key,
          role: role,

          /**
           * onMouseMove is used as it is only triggered by actual mouse movement
           */
          onMouseMove: Object(react_selection_["composeEventHandlers"])(onMouseMove, function () {
            if (key !== focusedKey) {
              _this.setControlledState({
                focusedKey: key
              });
            }
          })
        }, other);
      });

      _defineProperty(_assertThisInitialized(_this), "getNextItemProps", function () {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            key = _ref5.key,
            other = _objectWithoutProperties(_ref5, ["key"]);

        _this.nextKeys[key] = true;
        return _objectSpread({
          key: key,
          'aria-expanded': false
        }, other);
      });

      _defineProperty(_assertThisInitialized(_this), "getPreviousItemProps", function () {
        var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            key = _ref6.key,
            other = _objectWithoutProperties(_ref6, ["key"]);

        _this.previousKey = key;
        return _objectSpread({
          key: key,
          'aria-expanded': true
        }, other);
      });

      _defineProperty(_assertThisInitialized(_this), "convertGardenToPopperPlacement", function () {
        var placement = _this.props.placement;

        if (Object(react_theming_["isRtl"])(_this.props)) {
          return Object(react_tooltips_["getRtlPopperPlacement"])(placement);
        }

        return Object(react_tooltips_["getPopperPlacement"])(placement);
      });

      _this.state = {
        isOpen: false,
        id: react_selection_["IdManager"].generateId('garden-menu-container'),
        focusedKey: undefined,
        selectedKey: undefined,
        focusOnOpen: undefined,
        closedByBlur: undefined,
        defaultFocusedIndex: 0
      };
      return _this;
    }

    _createClass(MenuContainer, [{
      key: "attachClickOutsideHandler",
      value: function attachClickOutsideHandler() {
        var _this2 = this;

        this.getDocuments().forEach(function (doc) {
          doc.addEventListener('mousedown', _this2.handleOutsideMouseDown, true
          /* use capture */
          );
        });
      }
    }, {
      key: "detachClickOutsideHandler",
      value: function detachClickOutsideHandler() {
        var _this3 = this;

        this.getDocuments().forEach(function (doc) {
          doc.removeEventListener('mousedown', _this3.handleOutsideMouseDown, true
          /* use capture */
          );
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.detachClickOutsideHandler();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        var _this4 = this;

        var _this$getControlledSt7 = this.getControlledState(),
            isOpen = _this$getControlledSt7.isOpen,
            closedByBlur = _this$getControlledSt7.closedByBlur;

        var previousisOpen = this.isControlledProp('isOpen') ? prevProps.isOpen : prevState.isOpen;
        /**
         * Focus trigger element when menu is closed from selection or ESC key
         */

        if (!isOpen && previousisOpen) {
          if (!closedByBlur) {
            this.triggerReference && this.triggerReference.focus();
          }

          this.detachClickOutsideHandler();
        }
        /**
         * Focus menu element when opened
         */


        if (isOpen && !previousisOpen) {
          if (!this.menuReference) {
            throw new Error('Accessibility Error: You must apply the `menuRef` prop to the element that contains your menu.');
          }
          /**
           * Delaying the menu focus allows Popper.JS to reflow positioning based on boundary collisions.
           * Without this delay the focus event will cause any overflowed area to scroll.
           */


          setTimeout(function () {
            _this4.menuReference && _this4.menuReference.focus();
          }, 0);
          this.attachClickOutsideHandler();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this5 = this;

        var _this$props = this.props,
            children = _this$props.children,
            _this$props$render = _this$props.render,
            render = _this$props$render === void 0 ? children : _this$props$render,
            trigger = _this$props.trigger,
            eventsEnabled = _this$props.eventsEnabled,
            popperModifiers = _this$props.popperModifiers,
            appendToNode = _this$props.appendToNode,
            zIndex = _this$props.zIndex;

        var _this$getControlledSt8 = this.getControlledState(),
            isOpen = _this$getControlledSt8.isOpen,
            controlledFocusedKey = _this$getControlledSt8.focusedKey,
            controlledSelectedKey = _this$getControlledSt8.selectedKey,
            id = _this$getControlledSt8.id,
            defaultFocusedIndex = _this$getControlledSt8.defaultFocusedIndex;

        this.textValueSelectionModels = {};
        this.nextKeys = {};
        this.previousKey = undefined;
        /**
         * We must decide whether the provided `selectedKey` is controlled
         */

        var selectedKey = this.isControlledProp('selectedKey') ? controlledSelectedKey : undefined;
        return external_react_default.a.createElement(external_react_popper_["Manager"], {
          tag: false
        }, external_react_default.a.createElement(external_render_fragment_default.a, null, external_react_default.a.createElement(external_react_popper_["Target"], null, function (_ref7) {
          var targetProps = _ref7.targetProps;
          var targetRef = targetProps.ref;
          return trigger && trigger({
            getTriggerProps: function getTriggerProps(props) {
              return _this5.getTriggerProps(_objectSpread({}, props));
            },
            triggerRef: function triggerRef(ref) {
              targetRef(ref);

              _this5.triggerRef(ref);
            },
            isOpen: typeof isOpen === 'undefined' ? false : isOpen
          });
        }), isOpen && external_react_default.a.createElement(external_react_popper_["Popper"], {
          placement: this.convertGardenToPopperPlacement(),
          eventsEnabled: eventsEnabled,
          modifiers: popperModifiers
        }, function (_ref8) {
          var popperProps = _ref8.popperProps,
              scheduleUpdate = _ref8.scheduleUpdate;
          var popperPlacement = popperProps['data-placement'];
          var outOfBoundaries = popperProps['data-x-out-of-boundaries'];
          var menu = external_react_default.a.createElement(MenuWrapper, {
            innerRef: popperProps.ref,
            style: popperProps.style,
            zIndex: zIndex
          }, external_react_default.a.createElement(react_modals_["FocusJailContainer"], {
            focusOnMount: false
          }, function (_ref9) {
            var getFocusJailContainerProps = _ref9.getContainerProps,
                containerRef = _ref9.containerRef;
            return external_react_default.a.createElement(react_selection_["SelectionContainer"], {
              id: id,
              direction: "vertical",
              focusedKey: controlledFocusedKey,
              selectedKey: selectedKey,
              defaultFocusedIndex: defaultFocusedIndex,
              onStateChange: function onStateChange(newState) {
                /**
                 * We only care if `selectedKey` is involved with the state change
                 */
                if (Object.prototype.hasOwnProperty.call(newState, 'selectedKey')) {
                  var newSelectedKey = newState.selectedKey;

                  if (newSelectedKey === undefined) {
                    newSelectedKey = selectedKey;
                  }

                  _this5.onItemSelected(newSelectedKey);

                  if (newState.selectedKey === undefined) {
                    newState.isOpen = false;
                  } else {
                    newState.isOpen = _this5.nextKeys[newState.selectedKey] || _this5.previousKey === newState.selectedKey;
                  }
                }

                _this5.setControlledState(newState);
              }
            }, function (_ref10) {
              var getContainerProps = _ref10.getContainerProps,
                  getSelectionItemProps = _ref10.getItemProps,
                  focusedKey = _ref10.focusedKey,
                  focusSelectionModel = _ref10.focusSelectionModel;
              return render({
                getMenuProps: function getMenuProps(props) {
                  return getFocusJailContainerProps(getContainerProps(_this5.getMenuProps(props, focusSelectionModel)));
                },
                getItemProps: function getItemProps(props) {
                  return getSelectionItemProps(_this5.getItemProps(props), {
                    selectedAriaKey: 'aria-checked'
                  });
                },
                getNextItemProps: function getNextItemProps(props) {
                  return getSelectionItemProps(_this5.getItemProps(_this5.getNextItemProps(props)));
                },
                getPreviousItemProps: function getPreviousItemProps(props) {
                  return getSelectionItemProps(_this5.getItemProps(_this5.getPreviousItemProps(props)));
                },
                menuRef: function menuRef(ref) {
                  containerRef(ref);

                  _this5.menuRef(ref);
                },
                placement: popperPlacement,
                outOfBoundaries: outOfBoundaries,
                scheduleUpdate: scheduleUpdate,
                focusedKey: focusedKey
              });
            });
          }));

          if (appendToNode) {
            return external_react_default.a.createElement(external_react_portal_["Portal"], {
              node: appendToNode
            }, menu);
          }

          return external_react_default.a.createElement(external_react_portal_["Portal"], null, menu);
        })));
      }
    }]);

    return MenuContainer;
  }(react_selection_["ControlledComponent"]);

  _defineProperty(MenuContainer_MenuContainer, "propTypes", {
    /**
     * Appends the menu to the provided element
     */
    appendToNode: external_prop_types_default.a.any,

    /**
     * @param {Object} renderProps
     * @param {Function} renderProps.getMenuProps - Props to be spread onto the containing menu element
     * @param {Function} renderProps.getItemProps - Props to be spread each selectable menu item. `({ key })` is required. Use `index` attribute for custom ordering.
     * @param {Function} renderProps.getNextItemProps - Props to be spread each next menu item. `({ key })` is required. Use `index` attribute for custom ordering.
     * @param {Function} renderProps.getPreviousItemProps - Props to be spread each previous menu item. `({ key })` is required. Use `index` attribute for custom ordering.
     * @param {Any} renderProps.menuRef - Callback for the ref of the element containing the menu items
     * @param {Any} renderProps.placement - The current Popper.JS placement of the Menu. Will update based on boundary conflicts.
     * @param {Any} renderProps.outOfBoundaries - Whether the current menu has escaped its boundary.
     * @param {Any} renderProps.scheduleUpdate - Method to force an update within Popper.js
     * @param {Any} renderProps.focusedKey - The currently focused key that was provided to `getItemProps()`
     */
    children: external_prop_types_default.a.func,

    /**
     * Callback for when a menu item has been selected by keyboard or mouse
     * @param {String} selectedKey - The key of the selected item
     */
    onChange: external_prop_types_default.a.func,

    /**
     * Whether Popper.js should update based on DOM resize events
     */
    eventsEnabled: external_prop_types_default.a.bool,

    /**
     * The root ID to use for descendants. A unique ID is created if none is provided.
     */
    id: external_prop_types_default.a.string,

    /**
     * Controls visibility of menu
     */
    isOpen: external_prop_types_default.a.bool,

    /**
     * Whether the component is disabled
     */
    disabled: external_prop_types_default.a.bool,

    /**
     * The currently focused item
     */
    focusedKey: external_prop_types_default.a.string,

    /**
     * The currently selected item.
     *
     * **IMPORTANT:** If you think you should be using this prop,
     * ensure that the @zendeskgarden/react-select package doesn't
     * cover your use case since there may be other accessibility
     * implications.
     */
    selectedKey: external_prop_types_default.a.string,

    /**
     * Returns all controlled state. Used for controlling usage.
     */
    onStateChange: external_prop_types_default.a.func,

    /**
     * These placements differ from the default naming of Popper.JS placements to help
     * assist with RTL layouts.
     */
    placement: external_prop_types_default.a.oneOf(['auto', 'top', 'top-start', 'top-end', 'end', 'end-top', 'end-bottom', 'bottom', 'bottom-start', 'bottom-end', 'start', 'start-top', 'start-bottom']),

    /**
     * Passes options to [Popper.JS Instance](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#new-popperreference-popper-options)
     */
    popperModifiers: external_prop_types_default.a.object,

    /**
     * Identical to children
     */
    render: external_prop_types_default.a.func,

    /**
     * @param {Object} renderProps
     * @param {Function} renderProps.getTriggerProps - Props to be spread onto the trigger element
     * @param {Function} renderProps.triggerRef - Callback for the ref of the element triggering the menu
     * @param {Boolean} renderProps.isOpen - Whether the Menu is currently visible
     */
    trigger: external_prop_types_default.a.func,

    /**
     * The default index to focus when the menu is opened
     */
    defaultFocusedIndex: external_prop_types_default.a.number,

    /**
     * The z-index of the popper.js placement container
     */
    zIndex: external_prop_types_default.a.number
  });

  _defineProperty(MenuContainer_MenuContainer, "defaultProps", {
    placement: 'bottom-start',
    eventsEnabled: true,
    zIndex: 1000
  });
  /* harmony default export */


  var containers_MenuContainer = Object(react_theming_["withTheme"])(MenuContainer_MenuContainer); // EXTERNAL MODULE: external "@zendeskgarden/react-utilities"

  var react_utilities_ = __webpack_require__(7); // EXTERNAL MODULE: external "classnames"


  var external_classnames_ = __webpack_require__(8);

  var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_); // EXTERNAL MODULE: ./node_modules/@zendeskgarden/css-menus/dist/index.css


  var dist = __webpack_require__(1);

  var dist_default = /*#__PURE__*/__webpack_require__.n(dist); // EXTERNAL MODULE: ./node_modules/@zendeskgarden/css-arrows/dist/index.css


  var css_arrows_dist = __webpack_require__(6);

  var css_arrows_dist_default = /*#__PURE__*/__webpack_require__.n(css_arrows_dist); // CONCATENATED MODULE: ./src/views/MenuView.js


  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function MenuView_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = MenuView_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function MenuView_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function MenuView_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var COMPONENT_ID = 'menus.menu_view';
  var PLACEMENT = {
    AUTO: 'auto',
    TOP: 'top',
    TOP_START: 'top-start',
    TOP_END: 'top-end',
    RIGHT: 'right',
    RIGHT_START: 'right-start',
    RIGHT_END: 'right-end',
    BOTTOM: 'bottom',
    BOTTOM_START: 'bottom-start',
    BOTTOM_END: 'bottom-end',
    LEFT: 'left',
    LEFT_START: 'left-start',
    LEFT_END: 'left-end'
  };

  var shouldShowArrow = function shouldShowArrow(_ref) {
    var arrow = _ref.arrow,
        placement = _ref.placement;
    return arrow && placement;
  };

  var retrieveMenuMargin = function retrieveMenuMargin(_ref2) {
    var arrow = _ref2.arrow,
        placement = _ref2.placement;
    var marginAmount = shouldShowArrow({
      arrow: arrow,
      placement: placement
    }) ? '8px' : '4px';

    if (placement === PLACEMENT.BOTTOM || placement === PLACEMENT.BOTTOM_START || placement === PLACEMENT.BOTTOM_END) {
      return "margin-top: ".concat(marginAmount, ";");
    }

    if (placement === PLACEMENT.TOP || placement === PLACEMENT.TOP_START || placement === PLACEMENT.TOP_END) {
      return "margin-bottom: ".concat(marginAmount, ";");
    }

    if (placement === PLACEMENT.LEFT || placement === PLACEMENT.LEFT_START || placement === PLACEMENT.LEFT_END) {
      return "margin-right: ".concat(marginAmount, ";");
    }

    if (placement === PLACEMENT.RIGHT || placement === PLACEMENT.RIGHT_START || placement === PLACEMENT.RIGHT_END) {
      return "margin-left: ".concat(marginAmount, ";");
    }

    return '';
  };
  /**
   * Accepts all `<ul>` props
   */


  var StyledMenuView = external_styled_components_default.a.ul.attrs({
    'data-garden-id': COMPONENT_ID,
    'data-garden-version': "4.3.18",
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(dist_default.a['c-menu'], (_classNames = {}, MenuView_defineProperty(_classNames, dist_default.a['c-menu--sm'], props.small), MenuView_defineProperty(_classNames, dist_default.a['c-menu--up'], props.placement === PLACEMENT.TOP || props.placement === PLACEMENT.TOP_START || props.placement === PLACEMENT.TOP_END), MenuView_defineProperty(_classNames, dist_default.a['c-menu--right'], props.placement === PLACEMENT.RIGHT || props.placement === PLACEMENT.RIGHT_START || props.placement === PLACEMENT.RIGHT_END), MenuView_defineProperty(_classNames, dist_default.a['c-menu--left'], props.placement === PLACEMENT.LEFT || props.placement === PLACEMENT.LEFT_START || props.placement === PLACEMENT.LEFT_END), MenuView_defineProperty(_classNames, dist_default.a['c-menu--down'], props.placement === PLACEMENT.BOTTOM || props.placement === PLACEMENT.BOTTOM_START || props.placement === PLACEMENT.BOTTOM_END), MenuView_defineProperty(_classNames, dist_default.a['is-open'], props.animate), MenuView_defineProperty(_classNames, dist_default.a['is-hidden'], props.hidden), MenuView_defineProperty(_classNames, css_arrows_dist_default.a['c-arrow'], shouldShowArrow(props)), MenuView_defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--r'], props.placement === PLACEMENT.LEFT), MenuView_defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--rt'], props.placement === PLACEMENT.LEFT_START), MenuView_defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--rb'], props.placement === PLACEMENT.LEFT_END), MenuView_defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--b'], props.placement === PLACEMENT.TOP), MenuView_defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--bl'], props.placement === PLACEMENT.TOP_START), MenuView_defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--br'], props.placement === PLACEMENT.TOP_END), MenuView_defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--l'], props.placement === PLACEMENT.RIGHT), MenuView_defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--lt'], props.placement === PLACEMENT.RIGHT_START), MenuView_defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--lb'], props.placement === PLACEMENT.RIGHT_END), MenuView_defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--t'], props.placement === PLACEMENT.BOTTOM), MenuView_defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--tl'], props.placement === PLACEMENT.BOTTOM_START), MenuView_defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--tr'], props.placement === PLACEMENT.BOTTOM_END), MenuView_defineProperty(_classNames, dist_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
    }
  }).withConfig({
    displayName: "MenuView__StyledMenuView",
    componentId: "sc-1inler5-0"
  })(["&&{position:relative;}:focus{outline:none;}", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(COMPONENT_ID, props);
  });
  var MenuView_MenuWrapper = external_styled_components_default.a.div.withConfig({
    displayName: "MenuView__MenuWrapper",
    componentId: "sc-1inler5-1"
  })(["", ";"], retrieveMenuMargin);

  var MenuView_MenuView = function MenuView(props) {
    var arrow = props.arrow,
        placement = props.placement;
    var menuRef = props.menuRef,
        otherRefs = MenuView_objectWithoutProperties(props, ["menuRef"]);
    return external_react_default.a.createElement(MenuView_MenuWrapper, {
      arrow: arrow,
      placement: placement
    }, external_react_default.a.createElement(StyledMenuView, _extends({
      innerRef: menuRef
    }, otherRefs)));
  };

  MenuView_MenuView.propTypes = {
    /**
     * All valid [Popper.JS Placements](https://popper.js.org/popper-documentation.html#Popper.placements)
     */
    placement: external_prop_types_default.a.oneOf([PLACEMENT.AUTO, PLACEMENT.TOP, PLACEMENT.TOP_START, PLACEMENT.TOP_END, PLACEMENT.RIGHT, PLACEMENT.RIGHT_START, PLACEMENT.RIGHT_END, PLACEMENT.BOTTOM, PLACEMENT.BOTTOM_START, PLACEMENT.BOTTOM_END, PLACEMENT.LEFT, PLACEMENT.LEFT_START, PLACEMENT.LEFT_END]),
    animate: external_prop_types_default.a.bool,
    small: external_prop_types_default.a.bool,
    hidden: external_prop_types_default.a.bool,
    arrow: external_prop_types_default.a.bool,

    /**
     * Ref of internal Menu container
     */
    menuRef: external_prop_types_default.a.func
  };
  /** @component */

  /* harmony default export */

  var views_MenuView = MenuView_MenuView; // CONCATENATED MODULE: ./src/views/items/Item.js

  function Item_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var Item_COMPONENT_ID = 'menus.item';
  /**
   * Accepts all `<li>` props
   */

  var Item = external_styled_components_default.a.li.attrs({
    'data-garden-id': Item_COMPONENT_ID,
    'data-garden-version': "4.3.18",
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(dist_default.a['c-menu__item'], (_classNames = {}, Item_defineProperty(_classNames, dist_default.a['is-active'], props.active), Item_defineProperty(_classNames, dist_default.a['is-focused'], props.focused), Item_defineProperty(_classNames, dist_default.a['is-hovered'], props.hovered), Item_defineProperty(_classNames, dist_default.a['is-disabled'], props.disabled), Item_defineProperty(_classNames, dist_default.a['is-checked'], props.checked), _classNames));
    }
  }).withConfig({
    displayName: "Item",
    componentId: "sc-1k91z32-0"
  })(["", ";", ";"], function (props) {
    return !props.focused && "&&&:hover {\n      background-color: inherit;\n    }\n  ";
  }, function (props) {
    return Object(react_theming_["retrieveTheme"])(Item_COMPONENT_ID, props);
  });
  Item.propTypes = {
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    checked: external_prop_types_default.a.bool
  };

  Item.hasType = function () {
    return Item;
  };
  /** @component */

  /* harmony default export */


  var items_Item = Item; // CONCATENATED MODULE: ./src/views/items/AddItem.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var AddItem_COMPONENT_ID = 'menus.add_item';
  /**
   * Accepts all `<li>` props
   */

  var AddItem = external_styled_components_default()(items_Item).attrs({
    'data-garden-id': AddItem_COMPONENT_ID,
    'data-garden-version': "4.3.18",
    className: dist_default.a['c-menu__item--add']
  }).withConfig({
    displayName: "AddItem",
    componentId: "ace3bm-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(AddItem_COMPONENT_ID, props);
  });
  AddItem.propTypes = {
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool
  };

  AddItem.hasType = function () {
    return AddItem;
  };
  /** @component */

  /* harmony default export */


  var items_AddItem = AddItem; // CONCATENATED MODULE: ./src/views/items/media/MediaItem.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var MediaItem_COMPONENT_ID = 'menus.media_item';
  /**
   * Accepts all `<li>` props
   */

  var MediaItem = external_styled_components_default()(items_Item).attrs({
    'data-garden-id': MediaItem_COMPONENT_ID,
    'data-garden-version': "4.3.18",
    className: dist_default.a['c-menu__item--media']
  }).withConfig({
    displayName: "MediaItem",
    componentId: "sc-1a7iyuc-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(MediaItem_COMPONENT_ID, props);
  });
  MediaItem.propTypes = {
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    checked: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var media_MediaItem = MediaItem; // CONCATENATED MODULE: ./src/views/items/NextItem.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var NextItem_COMPONENT_ID = 'menus.next_item';
  /**
   * Accepts all `<li>` props
   */

  var NextItem = external_styled_components_default()(items_Item).attrs({
    'data-garden-id': NextItem_COMPONENT_ID,
    'data-garden-version': "4.3.18",
    className: dist_default.a['c-menu__item--next']
  }).withConfig({
    displayName: "NextItem",
    componentId: "qhpdnw-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(NextItem_COMPONENT_ID, props);
  });
  NextItem.propTypes = {
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool
  };

  NextItem.hasType = function () {
    return NextItem;
  };
  /** @component */

  /* harmony default export */


  var items_NextItem = NextItem; // CONCATENATED MODULE: ./src/views/items/PreviousItem.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var PreviousItem_COMPONENT_ID = 'menus.previous_item';
  /**
   * Accepts all `<li>` props
   */

  var PreviousItem = external_styled_components_default()(items_Item).attrs({
    'data-garden-id': PreviousItem_COMPONENT_ID,
    'data-garden-version': "4.3.18",
    className: dist_default.a['c-menu__item--previous']
  }).withConfig({
    displayName: "PreviousItem",
    componentId: "sc-1lfu05w-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(PreviousItem_COMPONENT_ID, props);
  });
  PreviousItem.propTypes = {
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool
  };

  PreviousItem.hasType = function () {
    return PreviousItem;
  };
  /** @component */

  /* harmony default export */


  var items_PreviousItem = PreviousItem; // CONCATENATED MODULE: ./src/elements/Menu.js

  function Menu_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      Menu_typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      Menu_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return Menu_typeof(obj);
  }

  function Menu_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        Menu_defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function Menu_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Menu_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function Menu_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function Menu_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function Menu_defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function Menu_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) Menu_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) Menu_defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function Menu_possibleConstructorReturn(self, call) {
    if (call && (Menu_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return Menu_assertThisInitialized(self);
  }

  function Menu_getPrototypeOf(o) {
    Menu_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return Menu_getPrototypeOf(o);
  }

  function Menu_assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function Menu_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Menu_setPrototypeOf(subClass, superClass);
  }

  function Menu_setPrototypeOf(o, p) {
    Menu_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return Menu_setPrototypeOf(o, p);
  }

  function Menu_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var ScrollableMenuView = external_styled_components_default()(views_MenuView).withConfig({
    displayName: "Menu__ScrollableMenuView",
    componentId: "zxn2pf-0"
  })(["", ";"], function (_ref) {
    var maxHeight = _ref.maxHeight;
    return maxHeight ? "\n    max-height: ".concat(maxHeight, ";\n    overflow: auto;\n  ") : '';
  });

  var Menu_Menu = /*#__PURE__*/function (_ControlledComponent) {
    Menu_inherits(Menu, _ControlledComponent);

    function Menu() {
      var _getPrototypeOf2;

      var _this;

      Menu_classCallCheck(this, Menu);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = Menu_possibleConstructorReturn(this, (_getPrototypeOf2 = Menu_getPrototypeOf(Menu)).call.apply(_getPrototypeOf2, [this].concat(args)));
      Menu_defineProperty(Menu_assertThisInitialized(_this), "state", {
        focusedKey: undefined,
        isOpen: false,
        id: react_selection_["IdManager"].generateId('garden-menu')
      });
      return _this;
    }

    Menu_createClass(Menu, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            appendToNode = _this$props.appendToNode,
            _trigger = _this$props.trigger,
            defaultPlacement = _this$props.placement,
            eventsEnabled = _this$props.eventsEnabled,
            popperModifiers = _this$props.popperModifiers,
            arrow = _this$props.arrow,
            children = _this$props.children,
            onChange = _this$props.onChange,
            zIndex = _this$props.zIndex,
            maxHeight = _this$props.maxHeight,
            menuProps = Menu_objectWithoutProperties(_this$props, ["appendToNode", "trigger", "placement", "eventsEnabled", "popperModifiers", "arrow", "children", "onChange", "zIndex", "maxHeight"]);

        var _this$getControlledSt = this.getControlledState(),
            id = _this$getControlledSt.id,
            isOpen = _this$getControlledSt.isOpen,
            focusedKey = _this$getControlledSt.focusedKey;

        return external_react_default.a.createElement(containers_MenuContainer, {
          id: id,
          isOpen: isOpen,
          focusedKey: focusedKey,
          onStateChange: this.setControlledState,
          appendToNode: appendToNode,
          placement: defaultPlacement,
          eventsEnabled: eventsEnabled,
          popperModifiers: popperModifiers,
          zIndex: zIndex,
          onChange: onChange,
          trigger: function trigger(_ref2) {
            var getTriggerProps = _ref2.getTriggerProps,
                triggerRef = _ref2.triggerRef;

            var referencedTrigger = _trigger({
              ref: triggerRef,
              isOpen: typeof isOpen === 'undefined' ? false : isOpen
            });

            return Object(external_react_["cloneElement"])(referencedTrigger, getTriggerProps(referencedTrigger.props));
          }
        }, function (_ref3) {
          var getMenuProps = _ref3.getMenuProps,
              getItemProps = _ref3.getItemProps,
              getPreviousItemProps = _ref3.getPreviousItemProps,
              getNextItemProps = _ref3.getNextItemProps,
              menuRef = _ref3.menuRef,
              placement = _ref3.placement;
          return external_react_default.a.createElement(ScrollableMenuView, getMenuProps(Menu_objectSpread({
            placement: placement,
            arrow: arrow,
            menuRef: menuRef,
            maxHeight: maxHeight
          }, menuProps)), external_react_["Children"].map(children, function (child) {
            if (!Object(external_react_["isValidElement"])(child)) {
              return child;
            }

            var _child$props = child.props,
                textValue = _child$props.textValue,
                disabled = _child$props.disabled,
                childChildren = _child$props.children;
            var key = child.key;
            /**
             * Children with the `disabled` prop are not selectable
             */

            if (disabled) {
              return child;
            }

            if (Object(react_utilities_["hasType"])(child, items_AddItem) || Object(react_utilities_["hasType"])(child, items_Item) || Object(react_utilities_["hasType"])(child, media_MediaItem) || Object(react_utilities_["hasType"])(child, items_NextItem) || Object(react_utilities_["hasType"])(child, items_PreviousItem)) {
              /**
               * Automatically apply `textValue` if children is a string
               */
              var childrenTextValue = typeof childChildren === 'string' ? childChildren : undefined;
              var itemPropMapper = getItemProps;

              if (Object(react_utilities_["hasType"])(child, items_NextItem)) {
                itemPropMapper = getNextItemProps;
              } else if (Object(react_utilities_["hasType"])(child, items_PreviousItem)) {
                itemPropMapper = getPreviousItemProps;
              }

              return Object(external_react_["cloneElement"])(child, itemPropMapper(Menu_objectSpread({
                key: key,
                textValue: textValue || childrenTextValue,
                focused: focusedKey === key,
                children: childChildren
              }, child.props)));
            }

            return child;
          }));
        });
      }
    }]);
    return Menu;
  }(react_selection_["ControlledComponent"]);

  Menu_defineProperty(Menu_Menu, "propTypes", {
    /**
     * Animate opening of Menu
     */
    animate: external_prop_types_default.a.bool,

    /**
     * Appends the menu to the provided element
     */
    appendToNode: external_prop_types_default.a.any,

    /**
     * Whether to include an arrow on the visible arrow
     */
    arrow: external_prop_types_default.a.bool,

    /**
     * Menu Items you want to display. All children require a `key` prop
     */
    children: external_prop_types_default.a.node,

    /**
     * Whether Popper.js should update based on DOM resize events
     */
    eventsEnabled: external_prop_types_default.a.bool,
    id: external_prop_types_default.a.string,

    /**
     * Controls visibility of menu
     */
    isOpen: external_prop_types_default.a.bool,

    /**
     * The currently focused item
     */
    focusedKey: external_prop_types_default.a.string,

    /**
     * Returns all controlled state. Used for controlling usage.
     */
    onStateChange: external_prop_types_default.a.func,

    /**
     * @param {Object} renderProps
     * @param {Function} renderProps.ref - Callback to retrieve the trigger elements ref
     * @param {Boolean} renderProps.isOpen - Whether the Menu is currently visible
     */
    trigger: external_prop_types_default.a.func,

    /**
     * Callback for when a menu item has been selected by keyboard or mouse
     * @param {String} selectedKey - The key of the selected item
     */
    onChange: external_prop_types_default.a.func,

    /**
     * These placements differ from the default naming of Popper.JS placements to help
     * assist with RTL layouts.
     **/
    placement: external_prop_types_default.a.oneOf(['auto', 'top', 'top-start', 'top-end', 'end', 'end-top', 'end-bottom', 'bottom', 'bottom-start', 'bottom-end', 'start', 'start-top', 'start-bottom']),

    /**
     * Passes options to [Popper.JS Instance](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#new-popperreference-popper-options)
     */
    popperModifiers: external_prop_types_default.a.object,

    /**
     * The z-index of the popper.js placement container
     */
    zIndex: external_prop_types_default.a.number,

    /**
     * The max-height of the MenuView. Used to create scrollable menus.
     */
    maxHeight: external_prop_types_default.a.string
  });
  Menu_defineProperty(Menu_Menu, "defaultProps", {
    animate: true,
    eventsEnabled: true
  }); // CONCATENATED MODULE: ./src/views/items/header/HeaderIcon.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var HeaderIcon_COMPONENT_ID = 'menus.header_icon';

  var HeaderIcon_HeaderIcon = function HeaderIcon(_ref) {
    var children = _ref.children;
    return external_react_default.a.cloneElement(external_react_["Children"].only(children), {
      'data-garden-id': HeaderIcon_COMPONENT_ID,
      'data-garden-version': "4.3.18",
      className: dist_default.a['c-menu__item--header__icon']
    });
  };
  /** @component */

  /* harmony default export */


  var header_HeaderIcon = HeaderIcon_HeaderIcon; // CONCATENATED MODULE: ./src/views/items/header/HeaderItem.js

  function HeaderItem_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var HeaderItem_COMPONENT_ID = 'menus.header_item';
  /**
   * Accepts all `<li>` props
   */

  var HeaderItem = external_styled_components_default()(items_Item).attrs({
    'data-garden-id': HeaderItem_COMPONENT_ID,
    'data-garden-version': "4.3.18",
    className: function className(props) {
      return external_classnames_default()(dist_default.a['c-menu__item--header'], HeaderItem_defineProperty({}, dist_default.a['c-menu__item--header--icon'], props.containsIcon));
    }
  }).withConfig({
    displayName: "HeaderItem",
    componentId: "sc-1o8q4gp-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(HeaderItem_COMPONENT_ID, props);
  });
  HeaderItem.propTypes = {
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    checked: external_prop_types_default.a.bool,

    /** Applies icon styling */
    containsIcon: external_prop_types_default.a.bool
  };

  HeaderItem.hasType = function () {
    return HeaderItem;
  };
  /** @component */

  /* harmony default export */


  var header_HeaderItem = HeaderItem; // CONCATENATED MODULE: ./src/views/items/ItemMeta.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var ItemMeta_COMPONENT_ID = 'menus.item_meta';
  /**
   * Accepts all `<span>` props
   */

  var ItemMeta = external_styled_components_default.a.span.attrs({
    'data-garden-id': ItemMeta_COMPONENT_ID,
    'data-garden-version': "4.3.18",
    className: dist_default.a['c-menu__item__meta']
  }).withConfig({
    displayName: "ItemMeta",
    componentId: "hofgj6-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(ItemMeta_COMPONENT_ID, props);
  });
  /** @component */

  /* harmony default export */

  var items_ItemMeta = ItemMeta; // CONCATENATED MODULE: ./src/views/items/media/MediaBody.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var MediaBody_COMPONENT_ID = 'menus.media_body';
  /**
   * Accepts all `<div>` props
   */

  var MediaBody = external_styled_components_default.a.div.attrs({
    'data-garden-id': MediaBody_COMPONENT_ID,
    'data-garden-version': "4.3.18",
    className: dist_default.a['c-menu__item--media__body']
  }).withConfig({
    displayName: "MediaBody",
    componentId: "sc-1m3n72b-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(MediaBody_COMPONENT_ID, props);
  });
  /** @component */

  /* harmony default export */

  var media_MediaBody = MediaBody; // CONCATENATED MODULE: ./src/views/items/media/MediaFigure.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var MediaFigure_COMPONENT_ID = 'menus.media_figure';

  var MediaFigure_MediaFigure = function MediaFigure(_ref) {
    var children = _ref.children;
    return external_react_default.a.cloneElement(external_react_["Children"].only(children), {
      'data-garden-id': MediaFigure_COMPONENT_ID,
      'data-garden-version': "4.3.18",
      className: dist_default.a['c-menu__item--media__figure']
    });
  };
  /** @component */

  /* harmony default export */


  var media_MediaFigure = MediaFigure_MediaFigure; // CONCATENATED MODULE: ./src/views/Separator.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var Separator_COMPONENT_ID = 'menus.separator';
  /**
   * Accepts all `<li>` props
   */

  var Separator = external_styled_components_default.a.li.attrs({
    'data-garden-id': Separator_COMPONENT_ID,
    'data-garden-version': "4.3.18",
    role: 'separator',
    className: dist_default.a['c-menu__separator']
  }).withConfig({
    displayName: "Separator",
    componentId: "zrm4zm-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(Separator_COMPONENT_ID, props);
  });
  /** @component */

  /* harmony default export */

  var views_Separator = Separator; // CONCATENATED MODULE: ./src/index.js

  /* concated harmony reexport MenuContainer */

  __webpack_require__.d(__webpack_exports__, "MenuContainer", function () {
    return containers_MenuContainer;
  });
  /* concated harmony reexport Menu */


  __webpack_require__.d(__webpack_exports__, "Menu", function () {
    return Menu_Menu;
  });
  /* concated harmony reexport AddItem */


  __webpack_require__.d(__webpack_exports__, "AddItem", function () {
    return items_AddItem;
  });
  /* concated harmony reexport HeaderIcon */


  __webpack_require__.d(__webpack_exports__, "HeaderIcon", function () {
    return header_HeaderIcon;
  });
  /* concated harmony reexport HeaderItem */


  __webpack_require__.d(__webpack_exports__, "HeaderItem", function () {
    return header_HeaderItem;
  });
  /* concated harmony reexport Item */


  __webpack_require__.d(__webpack_exports__, "Item", function () {
    return items_Item;
  });
  /* concated harmony reexport ItemMeta */


  __webpack_require__.d(__webpack_exports__, "ItemMeta", function () {
    return items_ItemMeta;
  });
  /* concated harmony reexport MediaBody */


  __webpack_require__.d(__webpack_exports__, "MediaBody", function () {
    return media_MediaBody;
  });
  /* concated harmony reexport MediaFigure */


  __webpack_require__.d(__webpack_exports__, "MediaFigure", function () {
    return media_MediaFigure;
  });
  /* concated harmony reexport MediaItem */


  __webpack_require__.d(__webpack_exports__, "MediaItem", function () {
    return media_MediaItem;
  });
  /* concated harmony reexport NextItem */


  __webpack_require__.d(__webpack_exports__, "NextItem", function () {
    return items_NextItem;
  });
  /* concated harmony reexport PreviousItem */


  __webpack_require__.d(__webpack_exports__, "PreviousItem", function () {
    return items_PreviousItem;
  });
  /* concated harmony reexport MenuView */


  __webpack_require__.d(__webpack_exports__, "MenuView", function () {
    return views_MenuView;
  });
  /* concated harmony reexport Separator */


  __webpack_require__.d(__webpack_exports__, "Separator", function () {
    return views_Separator;
  });
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  if (false) {}
  /***/

}
/******/
]));